import { ChakraProvider } from '@chakra-ui/react';
import '../styles/globals.css';
import theme from '../chakra-theme';
import ErrorBoundary from '../components/ErrorBoundary';

function MyApp({ Component, pageProps }) {
  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout ?? ((page) => page);
  return (
    <ErrorBoundary>
      <ChakraProvider theme={theme}>
        {/* @ts-ignore */}
        {getLayout(<Component {...pageProps} />)}
      </ChakraProvider>
    </ErrorBoundary>
  );
}

export default MyApp;
